import { jsPDF } from "jspdf";

export function downloadReceipt(order, staffName) {
    const doc = new jsPDF({ unit: "mm", format: [80, 200] }); // thermal-receipt style, portable
    const pageW = 80;
    let y = 10;

    // Header
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text("Vinarstvi Strokay", pageW / 2, y, { align: "center" });
    y += 5;
    doc.setFont("times", "normal");
    doc.setFontSize(9);
    const paidAt = order.paid_at ? new Date(order.paid_at) : new Date();
    doc.text(paidAt.toLocaleString("cs-CZ"), pageW / 2, y, { align: "center" });
    y += 3;
    doc.text(`Stul ${order.table_label}`, pageW / 2, y, { align: "center" });
    y += 5;
    doc.setLineDashPattern([1, 1], 0);
    doc.line(5, y, pageW - 5, y);
    y += 5;

    // Table header
    doc.setFont("times", "bold");
    doc.setFontSize(9);
    doc.text("Polozka", 5, y);
    doc.text("Ks", 40, y, { align: "right" });
    doc.text("Cena", 55, y, { align: "right" });
    doc.text("Celkem", pageW - 5, y, { align: "right" });
    y += 2;
    doc.line(5, y, pageW - 5, y);
    y += 4;

    // Items
    doc.setFont("times", "normal");
    let total = 0;
    for (const it of order.items || []) {
        const lineTotal = it.price * it.qty;
        total += lineTotal;
        const wrapped = doc.splitTextToSize(it.name, 30);
        doc.text(wrapped, 5, y);
        doc.text(String(it.qty), 40, y, { align: "right" });
        doc.text(`${it.price} Kc`, 55, y, { align: "right" });
        doc.text(`${lineTotal} Kc`, pageW - 5, y, { align: "right" });
        y += Math.max(4, wrapped.length * 4);
    }

    // Total
    y += 2;
    doc.line(5, y, pageW - 5, y);
    y += 6;
    doc.setFont("times", "bold");
    doc.setFontSize(13);
    doc.text("CELKEM", 5, y);
    doc.text(`${total} Kc`, pageW - 5, y, { align: "right" });
    y += 6;

    // Payments breakdown
    if (order.payments?.length) {
        doc.setFont("times", "normal");
        doc.setFontSize(8);
        for (const p of order.payments) {
            const label = p.method === "cash" ? "Hotove" : p.method === "qr" ? "QR" : "Karta";
            doc.text(`${label}: ${p.amount} Kc`, pageW - 5, y, { align: "right" });
            y += 3.5;
        }
        y += 2;
    }

    // Staff
    doc.setFont("times", "italic");
    doc.setFontSize(9);
    doc.text(`Obsluhoval(a): ${staffName || order.staff_name || "-"}`, 5, y);
    y += 8;

    // Footer
    doc.setLineDashPattern([1, 1], 0);
    doc.line(5, y, pageW - 5, y);
    y += 5;
    doc.setFont("times", "normal");
    doc.setFontSize(9);
    doc.text("Dekujeme za navstevu!", pageW / 2, y, { align: "center" });
    y += 4;
    doc.setFontSize(8);
    doc.text("www.strokayvinarstvi.cz", pageW / 2, y, { align: "center" });

    doc.save(`uctenka-stul-${order.table_label}-${paidAt.toISOString().slice(0, 19).replace(/[:T]/g, "-")}.pdf`);
}
